import SlideFrame from './SlideFrame';

interface Tool { name: string; tag: string; desc: string; usage: string; url: string; color: string }
interface ToolGroup { title: string; color: string; tools: Tool[] }

interface Props {
  title: string; sub: string;
  groups: ToolGroup[];
  flow: string[];
  note: string;
}

function initials(name: string): string {
  const clean = name.replace(/\(.*?\)/g, '').trim();
  const parts = clean.split(/[\s-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return clean.slice(0, 2).toUpperCase();
}

export default function ToolCards({ title, sub, groups, flow, note }: Props) {
  return (
    <SlideFrame title={title} sub={sub}>
      {groups.map((group, gi) => (
        <div key={gi} className="tool-group">
          <div className="tool-group-title" style={{ borderLeftColor: group.color, color: group.color }}>
            {group.title}
          </div>
          <div className="tool-cards">
            {group.tools.map((tool, i) => (
              <div key={i} className="tool-card" style={{ borderTopColor: tool.color }}>
                <div className="tool-card-head">
                  <div className="tool-card-icon" style={{ background: tool.color }}>
                    {initials(tool.name)}
                  </div>
                  <div className="tool-card-name-wrap">
                    <div className="tool-card-name" style={{ color: tool.color }}>{tool.name}</div>
                    <div className="tool-card-tag">{tool.tag}</div>
                  </div>
                </div>
                <div className="tool-card-desc">{tool.desc}</div>
                <div className="tool-card-usage">{tool.usage}</div>
                <a className="tool-card-url" href={`https://${tool.url}`} target="_blank" rel="noopener noreferrer">{tool.url}</a>
              </div>
            ))}
          </div>
        </div>
      ))}
      <div className="tool-flow">
        {flow.map((step, i) => (
          <span key={i} className="tool-flow-step">
            {step}
            {i < flow.length - 1 && <span className="tool-flow-arr"> →</span>}
          </span>
        ))}
      </div>
      <div className="tool-note">{note}</div>
    </SlideFrame>
  );
}
